import React from "react";
import { Phone, MapPin, ExternalLink, Building2 } from "lucide-react";
import { Header } from "../components/Header";
import { Seo } from "../components/Seo";
import {
  Footer,
  PHONE_DISPLAY,
  PHONE_TEL,
  ADDRESS_STREET,
  ADDRESS_CITY,
  ADDRESS_COUNTRY,
  MAPS_URL,
} from "../components/Footer";

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <Seo
        title="Contact — Vytali | Coordonnées corporatives"
        description="Coordonnées officielles du siège social de Vytali : téléphone +1 581-202-1112, 2828 boulevard Laurier, bureau 700, Québec (Québec) G1V 0B9, Canada."
        path="/contact"
      />
      <Header />
      <main
        data-testid="contact-page"
        className="max-w-4xl mx-auto px-6 md:px-12 py-16"
      >
        <div className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-widest text-[#9C9C9C] mb-4">
          <Building2 className="w-4 h-4" />
          Coordonnées corporatives
        </div>
        <h1 className="text-4xl md:text-5xl font-display font-black tracking-tighter text-[#2B2B2B]">
          Contact
        </h1>
        <p className="mt-3 text-[#5C5C5C] max-w-xl leading-relaxed">
          Voici les coordonnées officielles du siège social de Vytali. Pour
          toute question générale, vous pouvez aussi utiliser l'assistant
          Vytali (icône chat en bas à droite).
        </p>

        <div className="mt-10 grid gap-6 md:grid-cols-2">
          <div
            data-testid="contact-phone-card"
            className="rounded-2xl border border-[#E5E0D8] bg-white p-6"
          >
            <div className="flex items-center gap-3 text-[#9C9C9C]">
              <Phone className="w-5 h-5" strokeWidth={2.2} />
              <span className="text-xs font-mono uppercase tracking-widest">
                Téléphone
              </span>
            </div>
            <a
              data-testid="contact-phone-link"
              href={`tel:${PHONE_TEL}`}
              className="mt-3 block text-2xl font-display font-black tabular-nums text-[#2B2B2B] hover:text-[#E63946] transition-colors"
            >
              {PHONE_DISPLAY}
            </a>
            <p className="mt-2 text-sm text-[#5C5C5C]">
              Appelez-nous directement depuis n'importe quel appareil.
            </p>
          </div>

          <div
            data-testid="contact-address-card"
            className="rounded-2xl border border-[#E5E0D8] bg-white p-6"
          >
            <div className="flex items-center gap-3 text-[#9C9C9C]">
              <MapPin className="w-5 h-5" strokeWidth={2.2} />
              <span className="text-xs font-mono uppercase tracking-widest">
                Siège social de Vytali
              </span>
            </div>
            <address className="not-italic mt-3 text-[#2B2B2B] leading-relaxed font-medium">
              {ADDRESS_STREET}
              <br />
              {ADDRESS_CITY}
              <br />
              {ADDRESS_COUNTRY}
            </address>
            <a
              data-testid="contact-directions-link"
              href={MAPS_URL}
              target="_blank"
              rel="noreferrer noopener"
              className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-[#E63946] hover:underline"
            >
              Obtenir l'itinéraire
              <ExternalLink className="w-3.5 h-3.5" strokeWidth={2.4} />
            </a>
          </div>
        </div>

        <p className="mt-8 text-xs font-mono text-[#9C9C9C] leading-snug">
          Cette adresse est celle du siège social de Vytali — ce n'est pas
          une adresse de restaurant partenaire. Les coordonnées des
          restaurants partenaires sont disponibles sur leur fiche
          individuelle depuis la page d'accueil.
        </p>
      </main>
      <Footer />
    </div>
  );
}
